import { gql, useQuery } from '@apollo/client';

const GET_MEMBERSHIP_DISPLAY_CONFIG = gql`
  query UseMembershipDisplayConfig_GetMembershipDisplayConfig {
    getMembershipDisplayConfig {
      settings {
        hidePayNow
        showActiveAndNonMembersOnly
      }
    }
  }
`;

/**
 * Reads tenant membership display settings:
 * - hidePayNow: when on, hide member-side Pay Now dialog, payment CTA card, and email Pay now button
 * - showActiveAndNonMembersOnly: when on, Contacts shows only Active Member / Non-Member
 *
 * `loading` stays true until we have a response (or cache hit), so UI can avoid
 * flashing full statuses before the flag is known.
 */
export const useMembershipDisplayConfig = (): {
  hidePayNow: boolean;
  showActiveAndNonMembersOnly: boolean;
  loading: boolean;
} => {
  const { data, loading } = useQuery(GET_MEMBERSHIP_DISPLAY_CONFIG, {
    fetchPolicy: 'cache-first',
  });

  const settings = data?.getMembershipDisplayConfig?.settings;
  // Wait until we have data — don't treat "unknown" as switch-off (causes status flash)
  const isConfigLoading = loading && !data;

  return {
    hidePayNow: settings?.hidePayNow === true,
    showActiveAndNonMembersOnly:
      settings?.showActiveAndNonMembersOnly === true,
    loading: isConfigLoading,
  };
};
